import React, { useState } from "react";
import {
    Grid,
    Typography,
    TextField,
    makeStyles,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@material-ui/core";
import { format } from "date-fns";
import api from "../../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    summaryItem: {
        marginBottom: theme.spacing(2),
    },
}));

const CampaignReviewStep = ({ campaign, onChange }) => {
    const classes = useStyles();
    const [testModalOpen, setTestModalOpen] = useState(false);
    const [testEmail, setTestEmail] = useState("");
    const [sendingTest, setSendingTest] = useState(false);

    // Format date for datetime-local input (yyyy-MM-ddThh:mm)
    const formattedScheduledAt = campaign.scheduledAt
        ? format(new Date(campaign.scheduledAt), "yyyy-MM-dd'T'HH:mm")
        : "";

    const handleDateChange = (e) => {
        onChange("scheduledAt", new Date(e.target.value));
    };

    const handleSendTest = async () => {
        setSendingTest(true);
        try {
            await api.post(`/email-campaigns/${campaign.id}/test`, { email: testEmail });
            toast.success("E-mail de teste enviado!");
            setTestModalOpen(false);
        } catch (err) {
            toast.error("Erro ao enviar teste.");
        }
        setSendingTest(false);
    };

    return (
        <div className={classes.root}>
            <Typography variant="h6" style={{ marginBottom: 20 }}>
                Revisão e Agendamento
            </Typography>

            <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                    <div className={classes.summaryItem}>
                        <Typography variant="subtitle2">Nome da Campanha:</Typography>
                        <Typography variant="body1">{campaign.name}</Typography>
                    </div>
                    <div className={classes.summaryItem}>
                        <Typography variant="subtitle2">Janela de Envio:</Typography>
                        <Typography variant="body1">{campaign.sendWindowStart} até {campaign.sendWindowEnd}</Typography>
                    </div>
                    <div className={classes.summaryItem}>
                        <Typography variant="subtitle2">Contatos Importados:</Typography>
                        <Typography variant="body1">{campaign.totalContacts}</Typography>
                    </div>
                    <div className={classes.summaryItem}>
                        <Typography variant="subtitle2">Assunto:</Typography>
                        <Typography variant="body1">{campaign.subject}</Typography>
                    </div>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography variant="h6" gutterBottom>Definir Agendamento</Typography>
                    <TextField
                        fullWidth
                        label="Data e Hora de Início"
                        type="datetime-local"
                        variant="outlined"
                        value={formattedScheduledAt}
                        onChange={handleDateChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        helperText="Mínimo 5 minutos no futuro"
                    />

                    <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        style={{ marginTop: 20 }}
                        onClick={() => setTestModalOpen(true)}
                    >
                        Enviar E-mail de Teste
                    </Button>
                </Grid>
            </Grid>

            {/* Modal de Teste */}
            <Dialog open={testModalOpen} onClose={() => setTestModalOpen(false)}>
                <DialogTitle>Enviar Teste</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="E-mail de destino"
                        type="email"
                        fullWidth
                        value={testEmail}
                        onChange={(e) => setTestEmail(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setTestModalOpen(false)} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleSendTest} color="primary" disabled={sendingTest}>
                        {sendingTest ? "Enviando..." : "Enviar"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CampaignReviewStep;
